<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@let value = $_value() !== undefined ? $_value() : $controlValue();
@let disabled = $disabled() !== undefined ? $disabled() : $controlDisabled();

<label
  class="flex w-fit items-center !px-[2px]"
  [style.padding]="$innerPadding() | cssValue"
  [style.gap]="$gap() | cssValue"
  [class.disab]="disabled"
  [class.readonly]="$readonly()"
  [matTooltip]="!disabled ? $tooltip() : $tooltipWhenDisabled()"
  (click)="$event.stopPropagation()"
  >
  @if ($labelLeft() !== null) {
  <span class="label-container">
    <p
      class="text-left whitespace-nowrap"
      [style.fontSize]="$labelFontSize() | cssValue"
      [style.color]="$labelColor() | cssValue"
      >{{ $labelLeft() }}</p>
    <p
      class="text-left whitespace-nowrap !font-bold invisible"
      [style.fontSize]="$labelFontSize() | cssValue"
      [style.color]="$labelColor() | cssValue"
      >{{ $labelLeft() }}</p>
  </span>
  }
  <span class="input-container">
    <input
      type="checkbox"
      [style.width]="'calc(50px * ' + $scale() + ')'"
      [style.height]="'calc(25.5px * ' + $scale() + ')'"
      [disabled]="disabled || $readonly()"
      [checked]="value"
      (click)="onInputClick($event)"
    >
    <span
      class="indicator"
      [style.height]="'calc(7px * 2 * ' + $scale() + ')'"
      [style.width]="'calc(7px * 2 * ' + $scale() + ')'"
      [style.top]="'calc(50% - 7px *' + $scale() + ')'"
      [style.left]="!value ? ('calc(7px * ' + $scale() + ')') : ('calc(7px * 4.4 * ' + $scale() + ')')"
    ></span>
  </span>
  @if ($labelRight() !== null) {
    <span class="label-container">
      <p
        class="text-right whitespace-nowrap"
        [style.fontSize]="$labelFontSize() | cssValue"
        [style.color]="$labelColor() | cssValue"
      >{{ $labelRight() }}</p>
      <p
        class="text-right whitespace-nowrap !font-bold invisible"
        [style.fontSize]="$labelFontSize() | cssValue"
        [style.color]="$labelColor() | cssValue"
      >{{ $labelRight() }}</p>
    </span>
  }
</label>
